import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import {
  JssRouteBuilderService,
  getLanguage,
  getServiceNavigationRootName,
} from '@core/jss-routing';
import {
  ActiveLinkService,
  getNavigationItems,
  showCategories,
} from '@core/navigation-store';
import { Store, select } from '@ngrx/store';
import type { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { AsyncPipe } from '@angular/common';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

import { SidebarNavComponent } from '../sidebar-nav.component';

@Component({
  selector: 'wl-sidebar-nav-container',
  templateUrl: './sidebar-nav-container.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SidebarNavComponent, CSCaptureDirective, AsyncPipe],
})
export class SidebarNavContainerComponent {
  readonly rendering = input<ComponentRendering>();
  readonly #store$: Store<any> = inject(Store);
  readonly #urlBuilder: JssRouteBuilderService = inject(JssRouteBuilderService);
  readonly #activeLinkService = inject(ActiveLinkService);

  language$ = this.#store$.pipe(select(getLanguage));
  items$ = this.#store$.pipe(
    getNavigationItems(this.#store$, this.#urlBuilder, this.#activeLinkService)
  );
  title$ = this.#store$.pipe(getServiceNavigationRootName);
  showCategories$ = this.#store$.pipe(
    showCategories(this.#store$, this.#urlBuilder, this.#activeLinkService)
  );
}
